import { Component, OnInit } from '@angular/core';
import { interval } from 'rxjs';
import { map } from 'rxjs/operators'
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { AddCodingcafeDialogComponent } from '../add-codingcafe-dialog/add-codingcafe-dialog.component';
import { AddMcqquestionDialogComponent } from '../add-mcqquestion-dialog/add-mcqquestion-dialog.component';
import { HttpService } from '../../../services/http/http.service';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {
  showHachathon: boolean = false;
  constructor(private router: Router,
    private dialog: MatDialog,
    private httpService: HttpService) { }

  ngOnInit() {
    interval(1000).pipe(
      map((x) => { /* your code here */ console.log(x) })
    );
  }
  goToQuestions() {
    this.router.navigate(['questions'])
  }

  openCodingCafeDialog() {
    const dialogRef = this.dialog.open(AddCodingcafeDialogComponent, {

    })

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    })
  }
  openMCQquestionDialog() {
    const dialogRef = this.dialog.open(AddMcqquestionDialogComponent, {
    })

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    })
  }

  showHackathonComponent() {
    this.showHachathon = true;
  }

  redirectTo(path) {
    this.httpService.redirectTo(path);
  }
}
